import React, { useState, useEffect } from "react";
import "../../../assets/css/cms/Products.css";
import CustomEditor5 from "../../../utils/ckEditor5";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import { getTermsAndCondition, postTermsAndCondition, clearMessage, clearGetTermsAndConditionReponse } from "../../../../store/slices/staticPages"
import Alert from "@mui/material/Alert";
//Datepicker
import DesktopDatePicker from "@mui/lab/DatePicker";
import Box from '@mui/material/Box'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'

function TermsAndConditions() {
    const dispatch = useDispatch();
    const [publishStatus, setPublishStatus] = useState(false)
    const [text, setText] = useState('')
    const [versiondate, setVersionDate] = useState(new Date())
    const [newErrors, setErrors] = useState('')

    const { termsAndConditionData, postTermsAndConditionData, teamsAndConditionDataError, postTermsAndConditionError, message } = useSelector((state) => {
        return state.staticPagesReducer;
    });

    useEffect(() => {
        dispatch(getTermsAndCondition({ type: "Terms_Condition" }))
    }, [])

    useEffect(() => {
        if (termsAndConditionData) {
            setText(termsAndConditionData?.text)
            setPublishStatus(termsAndConditionData?.is_published)
            setVersionDate(termsAndConditionData?.version_date)
        }
    }, [termsAndConditionData])

    useEffect(() => {
        if (message) {
            setTimeout(() => {
                dispatch(clearMessage());
            }, 2000);
        }

    }, [message]);

    const handleSubmit = (e) => {
        e.preventDefault();
        let data = {}
        data.text = text
        data.is_published = publishStatus
        data.type = "Terms_Condition"
        data.version_date = versiondate
        dispatch(postTermsAndCondition(data))
    }

    useEffect(() => {
        if (!text) setErrors('this is mandatory field')
        else setErrors('')
    }, [text])

    return (
        <div>
            <div className={"notification_popup"}>
                {message
                    && (
                        <Alert severity={(postTermsAndConditionError || teamsAndConditionDataError) ? `error` : `success`}>
                            {" "}
                            {message?.detail || message}
                        </Alert>
                    )}
            </div>
            <div className={"url_other_details"}>
                <div className={"examfilter"}>
                    <h4>Terms & Conditions</h4>
                    <br></br>
                    <Row>
                        <Col sm={12}>
                            <Form.Group className="mb-3" controlId="synopsis">
                                <Form.Label>Description</Form.Label>
                                {(text || text==undefined||text=== '' || text===null)&&(
                                    <CustomEditor5
                                        name="description"
                                        initData={text}
                                        onChange={(data) => {
                                            setText(data);
                                        }} 
                                    />
                                )}
                                {newErrors && (
                                    <div className="text text-danger">{newErrors}</div>
                                )}
                            </Form.Group>

                        </Col>
                    </Row>
                    <Row className="my-4">
                        <Col md={4} sm={2}>
                            <Form.Group className="mb-3 date_input" controlId="Version date">
                                <Form.Label>This field specifies the draft date of the latest document. Select the draft date here</Form.Label>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        label="This field specifies the draft date of the latest document. Enter the draft date here"
                                        value={versiondate}
                                        onChange={(date) => {
                                            setVersionDate(date.toISOString());
                                        }}
                                        renderInput={({
                                            inputRef,
                                            inputProps,
                                            InputProps,
                                        }) => (
                                            <Box
                                                sx={{ display: "flex", alignItems: "center" }}
                                            >
                                                <Form.Control
                                                    ref={inputRef}
                                                    {...inputProps}
                                                    className={"input_pd"}
                                                    disabled
                                                />
                                                {InputProps?.endAdornment}
                                            </Box>
                                        )}
                                    />
                                </LocalizationProvider>

                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={11}>
                            <div className={""}>
                                <Form.Group className="mb-3">
                                    <div className="d-flex">
                                        <Form.Check
                                            id="check"
                                            className={"checkbox"}
                                            checked={publishStatus}
                                            onChange={(event) =>
                                                setPublishStatus(
                                                    event.target.checked
                                                )
                                            }
                                        />
                                        <Form.Label htmlFor="check"> Publish</Form.Label>
                                    </div>
                                </Form.Group>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="mt-4">
                    <button
                        className={`exam_button ${newErrors ? 'disabled_button' : ''}`}
                        type="submit"
                        onClick={(e) => handleSubmit(e)}
                        disabled={newErrors} >
                        Save
                    </button>
                </div>

            </div>
        </div>
    );

}
export default TermsAndConditions;